import { useAsyncTypeahead } from "../hooks";
import { ValidationError } from "./Form";
import { SvgSprite } from "./SvgSprite";
import { AsyncTypeahead, AsyncTypeaheadProps } from "./Typeahead";

export interface MultiLocationTypeaheadProps<T>
  extends Omit<AsyncTypeaheadProps<T>, "isLoading" | "onSearch"> {
  idx: number;

  onRemove: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  touched: boolean;
  error: string;
  defaultOptions?: T[];

  showRemoveBtn?: boolean;
}

export const MultiLocationTypeahead = <T,>({
  id,
  idx,
  onRemove,
  defaultOptions = [],
  showRemoveBtn = true,
  inputProps,
  ...rest
}: MultiLocationTypeaheadProps<T>): JSX.Element => {
  const locationTypeahead = useAsyncTypeahead<T>({
    url: (q) => `/api/locations?query=${q}`,
    onSuccess: (res) => {
      console.log(res);
      return res;
    },
    defaultOptions,
  });

  return (
    <div className="form-group">
      <label className="sr-only" htmlFor={id}>
        Location {idx}
      </label>

      <div className="position-relative">
        <AsyncTypeahead<T>
          id={id}
          {...locationTypeahead}
          {...rest}
          inputProps={Object.assign({}, inputProps, {
            "aria-describedby": [
              rest.touched && !!rest.error ? `${id}-error-message` : null,
              inputProps?.["aria-describedby"],
            ]
              .filter((x): x is string => x != null)
              .join(" "),
          })}
          hideValidation={true}
        />
        {showRemoveBtn && (
          <button
            type="button"
            className="btn btn-link"
            css={`
              position: absolute;
              top: 0;
              right: 0;
            `}
            onClick={onRemove}
            aria-label={`Remove location ${idx}`}
          >
            <SvgSprite
              id="icons:close"
              width={16}
              height={16}
              aria-label="Remove"
            />
          </button>
        )}
      </div>

      {rest.touched && !!rest.error && (
        <ValidationError
          errorId={`${id}-error-message`}
          className="d-block"
          message={rest.error}
        />
      )}
    </div>
  );
};
